import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { PedidoAnexo } from '../../models/pedido-anexo';
import { FilaTarefaStatusLog } from '../../models/filas/fila-tarefa-status-log';
import { CarregandoService } from '../../services/carregando.service';
import { GlobalService } from '../../services/global.service';
import { NotificacaoService } from '../../services/notificacao.service';
import { FilaTarefaService } from '../../services/fila-tarefa.service';
import { FilaService } from '../../services/fila.service';
import { FilaTarefa } from '../../models/filas/fila-tarefa';
import { HistoricoModalComponent } from '../modals/historico-modal/historico-modal.component';
import { UsuarioLogado } from 'src/app/models/usuario-logado';

@Component({
  selector: 'app-monitor-conferencia',
  templateUrl: './monitor-conferencia.component.html',
  styleUrls: ['./monitor-conferencia.component.scss']
})
export class MonitorConferenciaComponent implements OnInit, OnChanges {
  @Input() filaTarefa: FilaTarefa;
  logs: FilaTarefaStatusLog[] = [];
  tabIndex = 0;
  usuarioLogado: UsuarioLogado;
  @ViewChild('historicoComp', { static: false }) historicoComp: HistoricoModalComponent;

  constructor(private carregandoService: CarregandoService, private notificacaoService: NotificacaoService,
    private globalService: GlobalService, private filaTarefaService: FilaTarefaService) { }

  async ngOnInit() {
    this.usuarioLogado = await this.globalService.consultaUsuario();
    this.buscarDados();
  }

  async ngOnChanges(changes: SimpleChanges) {

    if (changes.filaTarefa && changes.filaTarefa.currentValue !== changes.filaTarefa.previousValue)
    {
      await this.atualizar();
    }
  }

  async atualizar() {
    this.buscarDados();
  }

  buscarDados() {
    if (this.filaTarefa) {
      this.buscarLogs();
    }
  }

  buscarLogs() {
    this.carregandoService.mostra('buscarLogs');
    this.filaTarefaService.consultarLog(this.filaTarefa.id).subscribe(dados => {
      this.logs = dados;
      this.carregandoService.esconde('buscarLogs');
    }, (erro) => {
      this.carregandoService.esconde('buscarLogs');
      this.notificacaoService.erro(erro);
    });

    if (this.historicoComp !== null && this.historicoComp !== undefined) {
      this.historicoComp.buscarTarefasDoPedido();
    }
  }

  changeTabIndex(index) {

    this.tabIndex = index;

    if (index === 1) {
      // this.selecionarAnexo();
    }
  }

}
